import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead } from "./Primitives";

export const Faq = ({ texts, faqs }) => (
  <section id="faq" data-testid="faq-section" className="relative border-b border-paper-line ap-section">
    <div className="ap-container grid gap-8 lg:grid-cols-[0.72fr_1.28fr] lg:gap-14">
      <SectionHead stamp="AP · FAQ" title={texts.faq_h2} />
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((f, i) => (
          <AccordionItem key={f.id} value={f.id} className="border-b border-paper-line">
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className="py-5 text-left font-display text-base font-bold uppercase tracking-wide text-ink hover:text-signal hover:no-underline sm:text-lg"
            >
              {f.question}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="ap-body pb-6 text-charcoal">
              {f.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
